import Vue from 'vue';
import Router from 'vue-router';

import About from './views/About';
import Home from './views/Home';
import Login from './views/Login';
import Lost from './views/Lost';
import PasswordReset from './views/PasswordReset';
import PasswordResetConfirm from './views/PasswordResetConfirm';
import Register from './views/Register';
import VerifyEmail from './views/VerifyEmail';
import CvEdit from './views/CvEdit';
import LandingPage from './views/LandingPage';
import MyCVListView from './views/MyCVListView';
import TemplateChoiceView from './views/TemplateChoiceView';
// import PreviewCV from './views/CvPreview';
import UserProfileView from './views/UserProfileView';
import CguCgv from './views/CguCgv';
import AdvicesCvFreeAccess from './views/AdvicesCvFreeAccess';

import store from './store';

const requireAuthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (!store.getters['auth/isAuthenticated']) {
        next('/');
      } else {
        next();
      }
    });
};

const requireUnauthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (store.getters['auth/isAuthenticated']) {
        next('/cv');
      } else {
        next();
      }
    });
};

const redirectLogout = (to, from, next) => {
  store.dispatch('auth/logout')
    .then(() => next('/'));
};

// https://raw.githubusercontent.com/vuejs/vue-router/dev/examples/scroll-behavior/app.js
// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition;
  } else {
    const position = {};

    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash;

      // specify offset of the element
      if (to.hash === '#anchor2') {
        position.offset = { y: 100 };
      }

      if (document.querySelector(to.hash)) {
        return position;
      }

      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return false;
    }

    return new Promise(resolve => {
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some(m => m.meta.scrollToTop)) {
        // coords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0;
        position.y = 0;
      }

      // wait for the out transition to complete (if necessary)
      this.app.$root.$once('triggerScroll', () => {
        // if the resolved position is falsy or an empty object,
        // will retain current scroll position.
        resolve(position);
      });
    });
  }
};

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior,
  // saveScrollPosition: true,
  routes: [
    // {
    //   path: '/',
    //   redirect: '/home',
    // },
    {
      path: '/',
      component: LandingPage,
      beforeEnter: requireUnauthenticated,
      meta: { keepAlive: false },
    },
    // {
    //   path: '/about',
    //   component: About,
    //   beforeEnter: requireAuthenticated,
    //   meta: { keepAlive: false },
    // },
    // {
    //   path: '/home',
    //   component: Home,
    //   beforeEnter: requireAuthenticated,
    //   meta: { keepAlive: false },
    // },
    {
      path: '/password_reset',
      component: PasswordReset,
      meta: { keepAlive: false },
    },
    {
      path: '/password_reset/:uid/:token',
      component: PasswordResetConfirm,
      meta: { keepAlive: false },
    },
    {
      path: '/register',
      component: Register,
      meta: { keepAlive: false },
    },
    {
      path: '/register/:key',
      component: VerifyEmail,
      meta: { keepAlive: false },
    },
    {
      path: '/login',
      component: Login,
      beforeEnter: requireUnauthenticated,
      meta: { keepAlive: false },
    },
    {
      path: '/logout',
      beforeEnter: redirectLogout,
      meta: { keepAlive: false },
    },
    {
      path: '/cv',
      component: MyCVListView,
      beforeEnter: requireAuthenticated,
      meta: { keepAlive: false },
    },
    {
      path: '/cv/:cv_id/edit',
      name: 'cvEdit',
      component: CvEdit,
      props: true, // important pour récupérer les param du push
      beforeEnter: requireAuthenticated,
      meta: { keepAlive: true }
    },
    {
      path: '/cv/:cv_id/cvmodels',
      name: 'modelChoice',
      component: TemplateChoiceView,
      props: true, // important pour récupérer les param du push
      beforeEnter: requireAuthenticated,
      meta: { keepAlive: true }
    },
    // {
    //   path: '/cv/:cv_id/preview',
    //   name: 'cvPreview',
    //   component: PreviewCV,
    //   props: true, // important pour récupérer les param du push
    //   beforeEnter: requireAuthenticated,
    //   meta: { keepAlive: false },
    // },
    {
      path: '/profil',
      component: UserProfileView,
      beforeEnter: requireAuthenticated,
      meta: { keepAlive: true },
    },
    {
      path: '/cgu',
      component: CguCgv,
      beforeEnter: requireUnauthenticated,
      meta: { keepAlive: false },
    },
    {
      path: '/conseils',
      component: AdvicesCvFreeAccess,
      beforeEnter: requireUnauthenticated,
      meta: { keepAlive: false },
    },
    {
      path: '*',
      component: Lost,
      meta: { keepAlive: false },
    },
  ],
});
